export const hubspotID = process.env.NEXT_PUBLIC_HUBSPOT_ID;
